import WsProvider from './provider/WSProvider'

var base64 = require('base64_js');
var serviceName = "index";
var userDataSidas = localStorage.getItem("userDataSidas") ? JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataSidas")))) : "";
var haberService = {
    imageUrlBuyuk: WsProvider.resim+"/"+userDataSidas["firmaKodu"]+"/buyuk/",
    imageUrlOrta: WsProvider.resim+"/"+userDataSidas["firmaKodu"]+"/kucuk/",
    imageUrlKucuk: WsProvider.resim+"/"+userDataSidas["firmaKodu"]+"/enkucuk/",
    path : "https://www.sidasas.com.tr/",
    tanimlama(kategori, link, baslik, altBaslik, icerik, seoBaslik, seoIcerik, belgeList, resimList, resimKonum, menuKonum,
              galeriKonum, baslamaTarihi, bitisTarihi,sayac,begen,durum) {
        var userDataSidas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataSidas"))));
        var param = {
            data: {
                yonetimId: userDataSidas["yonetimId"],
                userToken: userDataSidas["token"],
                firmaKodu: userDataSidas["firmaKodu"],
                link: link,
                kategori: kategori,
                baslik: baslik,
                altBaslik: altBaslik,
                icerik: icerik,
                seoBaslik: seoBaslik,
                seoIcerik: seoIcerik,
                belgeList: belgeList,
                resimList: resimList,
                resimKonum: resimKonum,
                menuKonum: menuKonum,
                galeriKonum: galeriKonum,
                baslamaTarihi: baslamaTarihi,
                bitisTarihi: bitisTarihi,
                sayac: sayac,
                begen: begen,
                durum: durum,
                dil: [],
                serviceName: "haber",
                methodName: "haberTanimlama"
            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },
    haberCount(durum) {
        var userDataSidas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataSidas"))));
        var param = {
            data: {
               yonetimId: userDataSidas["yonetimId"],
                userToken: userDataSidas["token"],
                firmaKodu: userDataSidas["firmaKodu"],
                durum: durum,
                serviceName: "haber",
                methodName: "haberCount"
            }
        };
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },
    haberListDetay(kategoriKodu, baslangic, limit, durum) {
        var userDataSidas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataSidas"))));
        var param = {
            data: {
               yonetimId: userDataSidas["yonetimId"],
                userToken: userDataSidas["token"],
                firmaKodu: userDataSidas["firmaKodu"],
                kategoriKodu: kategoriKodu,
                baslangic: baslangic,
                limit: limit,
                durum: durum,
                dil: "",
                serviceName: "haber",
                methodName: "haberListDetay"
            }
        };
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },
    haberDurumGuncelle(haberKodu, durum) {
        var userDataSidas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataSidas"))));
        var param = {
            data: {
               yonetimId: userDataSidas["yonetimId"],
                userToken: userDataSidas["token"],
                firmaKodu: userDataSidas["firmaKodu"],
                haberKodu: haberKodu,
                durum: durum,
                serviceName: "haber",
                methodName: "haberDurumGuncelle"
            }
        };
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },
    haberDetay(haberKodu) {
        var userDataSidas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataSidas"))));
        var param = {
            data: {
               yonetimId: userDataSidas["yonetimId"],
                userToken: userDataSidas["token"],
                firmaKodu: userDataSidas["firmaKodu"],
                haberKodu: haberKodu,
                serviceName: "haber",
                methodName: "haberDetay"
            }
        };
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },
    haberGuncelleme(haberKodu, updateList) {
        var userDataSidas = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataSidas"))));
        var param = {
            data: {
               yonetimId: userDataSidas["yonetimId"],
                userToken: userDataSidas["token"],
                firmaKodu: userDataSidas["firmaKodu"],
                haberKodu: haberKodu,
                updateList: updateList,
                serviceName: "haber",
                methodName: "haberGuncelle"
            }
        };
        var result = new Promise(function (resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;
    },

};
export default haberService